import { isMobile } from 'react-device-detect';
import { PrimaryButton } from 'src/styles/globalStyles/buttonStyles.styled';
import styled from 'styled-components';

export const GoalsTableContainer = styled.div`
  display: grid;
  width: 100%;
  grid-template-columns: 1fr 1px 1fr 1px 1fr 1px 1fr;
  gap: 16px;
  padding-left: 20px;
  padding-right: 20px;
  padding-bottom: 20px;
  height: 100vh;
  background: ${(props) =>
    props.theme.goalsTableContainerBackground}; // Use props for theme access
  scroll-snap-type: x mandatory;

  &:first-child {
    height: calc(100% - 34px);
  }

  @media (max-width: 768px) {
    grid-template-columns: 305px 305px 305px 305px;
    padding-left: 10px;
    height: 100%;
    gap: 5px;
    overflow-x: scroll;
    &:first-child {
      height: 100%;
    }
  }
`;

export const GoalsRow = styled.div`
  transition: all 0.3s ease;
  position: relative;
  display: flex;
  height: calc(100% - 84px);
  flex-direction: column;
  gap: 8px;
  align-items: center;
  max-width: 100%;
  overflow: scroll;
  scrollbar-width: none;
  padding-bottom: 16px;
  padding-top: ${() => (isMobile ? '0' : '20px')}; // Mobile check
  scroll-snap-align: center;

  @media (max-width: 768px) {
    height: 100%;
    padding-bottom: 120px;
  }
`;

export const GoalsRowDivider = styled.div`
  width: 1px;
  height: 100%;
  background: ${(props) =>
    props.theme.goalsRowDivider}; // Use props for theme access
  @media (max-width: 768px) {
    background: transparent;
  }
`;

export const AddNewGoalButton = styled(PrimaryButton)`
  min-width: 10px;
  min-height: 32px;
  width: 100%;
  position: sticky;
  z-index: 0;
  top: 0;
  &.maxWidth {
    max-width: 450px;
  }
  @media (min-width: 240px) {
    white-space: nowrap;
  }
`;

export const FocusBackground = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0.5;
  z-index: 1;
  background-color: black;
`;

export const MobileGoalsInputContainer = styled.div<{ position: number }>`
  width: 100vw;
  height: 150px;
  position: fixed;
  bottom: ${(props) => props.position}px; // Use props for dynamic values
  background: ${(props) =>
    props.theme.goalsTableContainerBackground}; // Use props for theme access
  display: flex;
`;
